import React from 'react';
import p1 from '../../Media/profile/p1.jfif'

const SecSid = () => {
    return (
        <div className='p-5 md:h-[650px] overflow-y-scroll border-r border-gray-400 w-'>
            <div className='md:flex justify-start border-2 border-gray-100 rounded-lg shadow-xl p-5 hover:border-primary-600 cursor-pointer mb-2'>
                <img class="w-16 h-16 rounded-full mr-3 flex justify-center" src={p1} alt="" />
                <div>
                    <div className='md:flex items-center mb-1'>
                        <h3 className='text-2xl font-bold mr-5 flex whitespace-nowrap'>John Dohi 1</h3>
                        <p className='text-red-600 flex whitespace-nowrap'>Full Stack Developer</p>
                    </div>
                    <div className='flex'>
                        <p className='text-primary-800 font-semibold bg-gray-300 py-1 px-1 rounded-md mr-3'>JavaScript</p>
                        <p className='text-rose-800 font-semibold bg-gray-300 py-1 px-1 rounded-md'>TypeScript</p>
                    </div>
                    <p className='text-emerald-400 my-1'>Some Street, Street, Country</p>
                    <p className='text-lg'>Lorem ipsum dolor, sit amet consectetur adipisicing elit.</p>
                </div>
            </div>
            <div className='md:flex justify-start border-2 border-gray-100 rounded-lg shadow-xl p-5 hover:border-primary-600 cursor-pointer mb-2'>
                <img class="w-16 h-16 rounded-full mr-3" src={p1} alt="" />
                <div>
                    <div className='md:flex items-center mb-1'>
                        <h3 className='text-2xl font-bold mr-5 flex whitespace-nowrap'>John Dohi 1</h3>
                        <p className='text-red-600 flex whitespace-nowrap'>Full Stack Developer</p>
                    </div>
                    <div className='flex'>
                        <p className='text-primary-800 font-semibold bg-gray-300 py-1 px-1 rounded-md mr-3'>JavaScript</p>
                        <p className='text-rose-800 font-semibold bg-gray-300 py-1 px-1 rounded-md'>TypeScript</p>
                    </div>
                    <p className='text-emerald-400 my-1'>Some Street, Street, Country</p>
                    <p className='text-lg'>Lorem ipsum dolor, sit amet consectetur adipisicing elit.</p>
                </div>
            </div>
            <div className='md:flex justify-start border-2 border-gray-100 rounded-lg shadow-xl p-5 hover:border-primary-600 cursor-pointer mb-2'>
                <img class="w-16 h-16 rounded-full mr-3" src={p1} alt="" />
                <div>
                    <div className='md:flex items-center mb-1'>
                        <h3 className='text-2xl font-bold mr-5 flex whitespace-nowrap'>John Dohi 1</h3>
                        <p className='text-red-600 flex whitespace-nowrap'>Full Stack Developer</p>
                    </div>
                    <div className='flex'>
                        <p className='text-primary-800 font-semibold bg-gray-300 py-1 px-1 rounded-md mr-3'>JavaScript</p>
                        <p className='text-rose-800 font-semibold bg-gray-300 py-1 px-1 rounded-md'>TypeScript</p>
                    </div>
                    <p className='text-emerald-400 my-1'>Some Street, Street, Country</p>
                    <p className='text-lg'>Lorem ipsum dolor, sit amet consectetur adipisicing elit.</p>
                </div>
            </div>
            <div className='md:flex justify-start border-2 border-gray-100 rounded-lg shadow-xl p-5 hover:border-primary-600 cursor-pointer mb-2'>
                <img class="w-16 h-16 rounded-full mr-3" src={p1} alt="" />
                <div>
                    <div className='md:flex items-center mb-1'>
                        <h3 className='text-2xl font-bold mr-5 flex whitespace-nowrap'>John Dohi 1</h3>
                        <p className='text-red-600 flex whitespace-nowrap'>Full Stack Developer</p>
                    </div>
                    <div className='flex'>
                        <p className='text-primary-800 font-semibold bg-gray-300 py-1 px-1 rounded-md mr-3'>JavaScript</p>
                        <p className='text-rose-800 font-semibold bg-gray-300 py-1 px-1 rounded-md'>TypeScript</p>
                    </div>
                    <p className='text-emerald-400 my-1'>Some Street, Street, Country</p>
                    <p className='text-lg'>Lorem ipsum dolor, sit amet consectetur adipisicing elit.</p>
                </div>
            </div>
               
        </div>
    );
};

export default SecSid;